/**
 * List component for transactions, managing list content and implementing event handler
 * 
 * Properties:
 * 
 *      wallets:    array, array of objects containing wallet transactions
 *      dispatch:   function, common dispatch function
 */

import React from "react";

import ResourceListItem from "./ResourceListItem";
 
 const ResourcesList = (props) => {

     let hasResourceNbr = false;
     if (props.resources.length > 0) {
         props.resources.map((resource) => {
             if (resource.resource_nbr !== null) {
                 hasResourceNbr = true;
             }
         });
     }

     return (
         <>
             <div id="inb-c-main-resources" className="inb-c-listing off-canvas-content" data-off-canvas-content="" key="inb-c-main-resources">
             <br/>
                 {props.resources.map((resource, index) => {
                     return (<>
                             <ResourceListItem
                                 resource={props.resources[index]}
                                 key={index+`_res`}
                                 hasResourceNbr={hasResourceNbr}
                                 index={index}
                                 openResourceGPS={props.openResourceGPS}
                                 filterChangedHandle={props.filterChangedHandle}
                                 filter={props.filter}
                                 dispatch={props.dispatch}
                                 onRemoveResource={props.onRemoveResource}
                                 setIndex={props.setIndex}
                                 _index={index}
                                 setInitialized={props.setInitialized}
                                 openChangeLog={props.openChangeLog}
                                 showNotification={props.showNotification}
                             />
                         </>
                     )
                 }
             )}
             </div>
         </>
     );
 }
 export default ResourcesList;